import { createFileRoute, Link, Navigate } from "@tanstack/react-router";
import { isNative } from "@/lib/nativeAuth";
import { useSeo } from "@/lib/seo";
import { SupportContent } from "@/components/legal/SupportContent";

export const Route = createFileRoute("/support")({
  component: SupportPage,
});

function SupportPage() {
  useSeo({
    title: "Support | GreenTrack",
    description:
      "Get help with GreenTrack — contact support, manage your subscription, restore purchases, or delete your account.",
    path: "/support",
  });

  if (isNative()) {
    return <Navigate to="/app" replace />;
  }

  return (
    <div className="min-h-screen bg-paper text-ink">
      <div className="mx-auto max-w-3xl px-6 py-16 sm:px-10 sm:py-24">
        <Link
          to={isNative() ? "/app" : "/"}
          className="text-[10px] font-bold uppercase tracking-widest text-ink-muted hover:text-ink-deep"
        >
          ← Back to GreenTrack
        </Link>

        <div className="mt-8">
          <SupportContent />
        </div>
      </div>
    </div>
  );
}
